import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function CheckoutCancel() {
    return (
        <div
            data-testid="checkout-cancel-page"
            className="min-h-screen bg-black text-white flex items-center justify-center px-6"
        >
            <div className="max-w-xl text-center">
                <XCircle className="mx-auto mb-6 text-signal" size={48} />
                <p className="label-mono">— Checkout Cancelled</p>
                <h1 className="font-display text-5xl md:text-7xl uppercase tracking-tight mt-4">
                    No worries.
                </h1>
                <p className="text-muted-foreground mt-4 max-w-md mx-auto">
                    Your card was not charged. The drop is still waiting.
                </p>
                <Link
                    to="/"
                    data-testid="back-home-link"
                    className="inline-flex items-center gap-2 mt-10 font-mono text-xs uppercase tracking-[0.25em] border-b border-white/30 pb-1 hover:border-white"
                >
                    <ArrowLeft size={14} />
                    Back to Drops
                </Link>
            </div>
        </div>
    );
}
